import {
    getAnchorMailboxHeaderForFolderId,
    getAnchorMailboxHeaderForItemId,
    getAuxMailboxHeaderForFolderId,
} from '../util/mailboxUtility';
import { trace } from 'owa-trace';
import RequestOptions from 'owa-service/lib/RequestOptions';

const HEADER_ANCHOR_MAILBOX = 'X-AnchorMailbox';
const HEADER_AUX_MAILBOX = 'X-AuxMailbox';

/**
 * returns the default request options based on params
 * @param folderId
 * @param itemId
 * @returns the RequestInit object
 */
export default function getDefaultRequestOptions(
    folderId?: string,
    itemId?: string
): RequestOptions | null {
    try {
        const requestOptions = {
            headers: new Headers(),
        };
        let anchorMailboxHeader = null;

        if (folderId) {
            anchorMailboxHeader = getAnchorMailboxHeaderForFolderId(folderId);

            const auxMailboxHeader = getAuxMailboxHeaderForFolderId(folderId);
            if (auxMailboxHeader) {
                requestOptions.headers.append(HEADER_AUX_MAILBOX, auxMailboxHeader);
            }
        } else if (itemId) {
            anchorMailboxHeader = getAnchorMailboxHeaderForItemId(itemId);
        }

        if (anchorMailboxHeader) {
            requestOptions.headers.append(HEADER_ANCHOR_MAILBOX, anchorMailboxHeader);
        }

        // More headers can be later added if requirements arise
        return requestOptions;
    } catch (e) {
        trace.error(
            ' getDefaultRequestOptions failed for folderId ' +
                folderId +
                ' and itemId ' +
                itemId +
                ' with error ' +
                e
        );
        return {};
    }
}
